var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-document-item-img"},[_c('img',{attrs:{"src":_vm.image},on:{"click":_vm.preview}})])}
var staticRenderFns = []

export { render, staticRenderFns }